import { useNavigate, useLocation } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import InvoicesPage from './InvoicesPage.jsx';
import SubscriptionsPage from './SubscriptionsPage.jsx';
import DonationsPage from './DonationsPage.jsx';

/**
 * Sammelseite "Einnahmen" — vereint Rechnungen + Abos in zwei Tabs, weil ein
 * Abo am Ende auch nur Rechnungen erzeugt. Der Tab-Wechsel rendert die
 * jeweilige bestehende Seite.
 */
export default function IncomePage() {
  const nav = useNavigate();
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const active = params.get('tab') || 'invoices';

  const setTab = (k) => {
    const next = new URLSearchParams(loc.search);
    if (k === 'invoices') next.delete('tab'); else next.set('tab', k);
    nav({ pathname: '/income', search: next.toString() ? `?${next}` : '' }, { replace: true });
  };

  return (
    <Tabs activeKey={active} onSelect={setTab} className="mb-3" mountOnEnter unmountOnExit>
      <Tab eventKey="invoices" title="Rechnungen">
        <InvoicesPage />
      </Tab>
      <Tab eventKey="subscriptions" title="Abos / Wiederkehrend">
        <SubscriptionsPage />
      </Tab>
      <Tab eventKey="donations" title="Spenden / Zuwendungen">
        <DonationsPage />
      </Tab>
    </Tabs>
  );
}
